import { useCallback, useEffect, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { useAsync, useCustomErrorCode, useAccountLockout, CUSTOM_ERROR_CODE } from 'helpers/hooks';
import { ToastContext } from 'contexts';
import axios from 'helpers/axios';
import { CHANGE_EMAIL } from 'constants/apis';

export default () => {
  const { t } = useTranslation();
  const { triggerToast } = useContext(ToastContext);
  const { getCustomError } = useCustomErrorCode();
  const { triggerAccountLockout } = useAccountLockout();

  const [result, doChangeEmail] = useAsync(
    useCallback(async ({ newEmail, password, recaptchaToken }) => {
      await axios.patch(CHANGE_EMAIL, {
        email: newEmail,
        password,
        recaptchaToken,
      });

      return newEmail;
    }, []),
    false
  );

  useEffect(() => {
    if (result.isError) {
      const { message, code } = getCustomError(result.error);

      if (code === CUSTOM_ERROR_CODE.LOCKED_OUT) {
        triggerAccountLockout();
      }

      triggerToast({ message, variant: 'error' });
    }
  }, [result.isError, result.error, triggerToast, getCustomError, triggerAccountLockout]);

  useEffect(() => {
    if (result.isSuccess) {
      triggerToast({
        message: t('settings.change_email.success', { email: result.data }),
        variant: 'success',
      });
    }
  }, [result.isSuccess, result.data, triggerToast, t]);

  return [result, doChangeEmail];
};
